/**
 * Represents the status of an API action.
 */
export enum ApiActionStatus {
    /**
     * No action is in progress.
     */
    None = 0,
    /**
     * An action is in progress.
     */
    InProgress = 1,
    /**
     * The action was successful.
     */
    Success = 2,
    /**
     * The action failed.
     */
    Failed = 3
}
